<template>
  <div class="treasure-upgrade-panel">
    <div class="artifact-list">
      <button v-click-sound-button class="h-btn LEFTARN" :disabled="prevDisable" @click="handlePrevPage"></button>
      <div class="artifact-list-wrapper">
        <div v-click-sound-button
             class="artifact-item h-outer-border around-4 bw2 bz0"
             :class="{ selected: selectedIndex === index, empty: !item.id }"
             v-for="(item, index) in treasureList" :key="item.name"
             @click="handleClickSynthesisArtifact(index)">
          <div class="artifact-wrapper h-effect equipment" :class="['quality-' + (item.quality || '')]">
            <img class="artifact-icon" :src="artifactUrl(item.id)" alt="">
          </div>
        </div>
      </div>
      <button v-click-sound-button class="h-btn RIGHTARN" :disabled="nextDisable" @click="handleNextPage"></button>
    </div>

    <p class="forging-help">大人，选择主宝物与副宝物</p>
    <div class="forging-content h-outer-border around-4 bw2 bz0 h-bg brown-2">

      <div class="forging-target" style="width: 128px;">
        <template v-if="!selectedMainTreasure">
          <div class="artifact-item empty h-outer-border around-4 bw2 bz0">
            <div class="artifact-wrapper h-effect equipment">
              <p class="choose-text" @click="handleChooseMainTreasure">+选择宝物（主）</p>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="artifact-item h-outer-border around-4 bw2 bz0">
            <div class="artifact-wrapper h-effect equipment" :class="['quality-' + selectedMainTreasure.quality]">
              <img class="artifact-icon" :src="artifactUrl(selectedMainTreasure.artifactId)" alt="">

              <div v-if="selectedMainTreasure.level > 0"
                   class="treasure-star">
                <img class="icon-treasure-star"
                     :src="`${$rHost}/img/common/icon_treasure_lv_${selectedMainTreasure.level}.png`"
                     alt="">
              </div>
            </div>
          </div>
          <div class="effects">
            <p class="effect">
              经验 {{ selectedMainTreasure.exp }}
              <span v-if="selectedAppendTreasure">
                <span class="color-green">（+{{ selectedAppendTreasure.levelExp }}）</span>
              </span>
            </p>
            <p class="effect">下级经验 {{ selectedMainTreasure.nextLevelExp }}</p>
          </div>
        </template>
      </div>

      <div class="upgrade-icon-block">
        <p class="append-exp" v-if="selectedAppendTreasure">+{{ selectedAppendTreasure.levelExp }} 经验</p>
        <img :src="`${$rHost}/img/common/icon/icon_arrow_right.png`" alt="">
      </div>

      <div class="forging-target" style="width: 128px;">
        <template v-if="!selectedAppendTreasure">
          <div class="artifact-item empty h-outer-border around-4 bw2 bz0">
            <div class="artifact-wrapper h-effect equipment">
              <p class="choose-text" @click="handleChooseAppendTreasure">+选择宝物（副）</p>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="artifact-item h-outer-border around-4 bw2 bz0">
            <div class="artifact-wrapper h-effect equipment" :class="['quality-' + selectedAppendTreasure.quality]">
              <img class="artifact-icon" :src="artifactUrl(selectedAppendTreasure.artifactId)" alt="">

              <div v-if="selectedAppendTreasure.level > 0"
                   class="treasure-star">
                <img class="icon-treasure-star"
                     :src="`${$rHost}/img/common/icon_treasure_lv_${selectedAppendTreasure.level}.png`"
                     alt="">
              </div>
            </div>
          </div>
          <div class="effects">
            <p class="effect">经验 {{ selectedAppendTreasure.exp }}</p>
            <p class="effect">材料经验 {{ selectedAppendTreasure.levelExp }}</p>
          </div>
        </template>
      </div>
    </div>

    <div class="footer">
      <button v-click-sound-button class="h-btn MUBCHCKN" :disabled="notEnough" @click="handleConfirm"></button>
      <button v-click-sound-button class="h-btn MUBCANCN" @click="handleClose"></button>
    </div>

    <MiniBackpack v-if="backpackShow"
                  :popup-title="miniBackpackTitle"
                  :artifact-id="selectedArtifactId"
                  :ignore-artifact="ignoreArtifact"
                  @submit="onTreasureSelected"
                  @close="backpackShow=false">
    </MiniBackpack>
  </div>
</template>

<script>
import MiniBackpack from '@/components/h-forging-factory/mini-backpack'
import API from '@js/api'
import { mapActions } from 'vuex'

export default {
  name: 'TreasureUpgrade',

  components: {
    MiniBackpack,
  },

  filters: {
    formatUpgradeEffect(item, index) {
      if (item.isPercent) {
        return +(item.value?.[index] * 100).toFixed(1) + '%'
      }
      return item.value?.[index]
    }
  },

  data () {
    return {
      selectedIndex: 0, // 选择的需要升星的宝物下标
      pager: {
        page: 0,
        pageSize: 7,
      },
      selectedMainTreasure: null,
      selectedAppendTreasure: null,
      backpackShow: false,
      miniBackpackTitle: '',
      isChooseMainTreasure: true,


    }
  },

  props: {
    treasureList: {
      type: Array,
    }
  },

  computed: {
    totalPage () {
      return Math.ceil(this.treasureList.length / this.pager.pageSize) || 1
    },

    // 选择的需要升星的宝物
    selectedArtifact () {
      return this.treasureList[this.selectedIndex] || {}
    },

    // 选择的需要升星的宝物 ID
    selectedArtifactId () {
      return this.selectedArtifact?.id
    },

    ignoreArtifact () {
      return [this.selectedMainTreasure?.id, this.selectedAppendTreasure?.id].filter((d) => d)
    },

    prevDisable () {
      return this.pager.page <= 0
    },

    nextDisable () {
      return this.pager.page >= this.totalPage - 1
    },

    notEnough () {
      return !this.selectedMainTreasure || !this.selectedAppendTreasure
    }
  },

  methods: {
    ...mapActions('hero', [
      'getBackpackItems',
    ]),

    ...mapActions('gameSocket', [
      'appendSystemMessage'
    ]),

    artifactUrl (id) {
      if (!id) {
        return ''
      }
      return `${this.$rHost}/img/artifact/ARTIFACT${id}.png`
    },

    handlePrevPage () {
      this.selectedIndex = 0
      this.pager.page = Math.max(0, this.pager.page - 1)
    },

    handleNextPage () {
      this.selectedIndex = 0
      this.pager.page = Math.min(this.totalPage - 1, this.pager.page + 1)
    },

    handleClickSynthesisArtifact (index) {
      const item = this.treasureList[index]
      if (!item?.id || this.selectedIndex === index) {
        return
      }

      this.selectedMainTreasure = null
      this.selectedAppendTreasure = null
      this.selectedIndex = index
    },

    handleChooseMainTreasure () {
      this.isChooseMainTreasure = true
      this.miniBackpackTitle = '选择主宝物'
      this.backpackShow = true
    },

    handleChooseAppendTreasure () {
      this.isChooseMainTreasure = false
      this.miniBackpackTitle = '选择副宝物'
      this.backpackShow = true
    },

    onTreasureSelected (artifact) {
      if (this.isChooseMainTreasure) {
        this.selectedMainTreasure = artifact
      } else {
        this.selectedAppendTreasure = artifact
      }
      console.log('artifact', artifact)
      this.backpackShow = false
    },

    async handleConfirm () {
      try {
        const res = await this.$confirm(`即将进行升星操作，副宝物经验将追加至主宝物，请确认。`)
        if (!res) {
          return
        }
        const mainTreasure = this.selectedMainTreasure
        const appendTreasure = this.selectedAppendTreasure
        await API.forgingFactory.treasureUpgrade({
          mainTreasure: this.selectedMainTreasure?.id,
          appendTreasure: this.selectedAppendTreasure?.id,
        })
        this.appendSystemMessage(`【${mainTreasure.nameCn}】已追加${appendTreasure.levelExp}点经验。`)
        this.getBackpackItems()
        this.selectedMainTreasure = null
        this.selectedAppendTreasure = null
      } catch (err) {
        this.$message(err)
      }
    },

    handleClose () {
      this.$emit('close', false)
    },
  },
}
</script>

<style lang="stylus" scoped>
.forging-help
  padding 30px 0 10px
  goldText1()
  text-align center
  font-size 14px

.forging-content
  display flex
  justify-content space-between
  padding 10px 5px
  height 130px
  .forging-details
    width 250px
    flex-basis 0
  .upgrade-icon-block
    display flex
    flex-direction column
    justify-content center
    align-items center
    width 90px
    .append-exp
      margin-bottom 5px
      goldText1()
    img
      max-width 100%
      vertical-align top
      transform scale(-1)
  .forging-target
    box-sizing content-box
    display flex
    flex-direction column
    justify-content center
    align-items center
    padding 0
    width 128px
    .artifact-item
      width 64px
      height 64px
      &.empty
        width 128px
      .artifact-wrapper
        position relative
        height 64px
      .choose-text
        position relative
        z-index 1
        display flex
        justify-content center
        align-items center
        width 128px
        height 64px
        font-size 12px
        goldText1()
        &:hover
          cursor pointer
          text-decoration underline
    .effects
      width 100%
      padding-top 5px
      text-align center
      .effect
        line-height 16px
        font-size 12px
        whiteText1()
  .forging-text
    goldText1()
    text-align center
    line-height 16px
    font-size 12px

.artifact-detail
  margin-top 10px
  .synthesis-list
    display flex
    justify-content center
    .synthesis-item
      box-sizing content-box
      width 42px
      padding 2px
      &:not(:last-child)
        margin-right 5px
      .artifact-wrapper
        width 42px
        height 42px
        .artifact-icon
          max-width 100%
          vertical-align top
      .artifact-amount
        whiteText1()
        margin-top 1px
        display flex
        justify-content center
        line-height 20px
        font-size 12px
        &.not-enough
          color $colorRed1

.artifact-list
  display flex
  justify-content space-evenly
  .h-btn.LEFTARN,
  .h-btn.RIGHTARN
    width 27px
    height 56px
    border 2px solid $colorGold
  .artifact-list-wrapper
    display flex
    width 575px
    justify-content center
  .artifact-item
    position relative
    padding 2px
    width 56px
    height 56px
    filter grayscale(0.75)
    .artifact-wrapper
      overflow hidden
      display flex
      align-items center
      justify-content center
      width 52px
      height 52px
      img
        width 100%
        vertical-align top
    &:not(:last-child)
      margin-right 2px
    &:not(.empty):hover
      cursor pointer
    &.selected
      filter grayscale(0)

.footer
  margin-top 40px
  display flex
  justify-content space-evenly
  > button
    box-sizing content-box

.treasure-star
  position absolute
  z-index 2
  display flex
  align-items center
  justify-content center
  top 0
  right -2px
  height 12px
  .level-text
    line-height 12px
    font-size 12px
    font-weight bold
    color orange
    transform scale(0.833)
    text-shadow 0 0 1px #fff, 0 1px 1px #212121
  .icon-treasure-star
    width 20px
    height 10px

</style>
